var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrustradius = function SvgTrustradius(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 19,
    fill: "none",
    viewBox: "0 0 112 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_2434_171178)",
    d: "M8.98.056c.075.037.15.074.206.13l3.223 3.223c.13.13.205.299.205.485v14.868c0 .13-.093.224-.224.224a.2.2 0 0 1-.149-.056l-3.037-3.037A.68.68 0 0 1 9 15.41V.056z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_2434_171178)",
    d: "M17.85.205a.8.8 0 0 1 .205-.15V15.41a.68.68 0 0 1-.205.484l-3.037 3.037a.214.214 0 0 1-.373-.149V3.913c0-.168.075-.354.205-.466z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_2434_171178)",
    d: "m23.7 12.018-.223-.224V8.627h-3.075a.23.23 0 0 0-.168.074l-2.198 2.2 7.043 7.06a.66.66 0 0 0 .484.187h3.708c.13 0 .224-.093.224-.224a.2.2 0 0 0-.056-.149z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_2434_171178)",
    d: "M18.316 0a.68.68 0 0 0-.485.205l-3.223 3.223c-.056.056-.093.13-.13.187h8.999v8.16L23.7 12l3.205-3.186a.68.68 0 0 0 .205-.484V3.913a.68.68 0 0 0-.205-.485L23.682.205A.68.68 0 0 0 23.197 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_2434_171178)",
    d: "M9.167.205A.68.68 0 0 0 8.683 0H.223A.215.215 0 0 0 0 .224C0 .279.019.335.075.39l3.037 3.037c.13.13.298.205.484.205h8.57c.243 0 .448.205.448.447v-.167a.68.68 0 0 0-.205-.485z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint5_linear_2434_171178)",
    d: "M17.831.205A.68.68 0 0 1 18.316 0h4.881c.187 0 .354.075.485.205l3.223 3.223c.13.13.205.298.205.485v.167a.453.453 0 0 0-.447-.447H14.887a.453.453 0 0 0-.447.447v-.167c0-.187.075-.354.205-.485z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint6_linear_2434_171178)",
    d: "M27.11 8.161a.453.453 0 0 1-.447.447h-6.074a.12.12 0 0 0-.112.112c0 .037.019.056.037.075l3.205 3.204 3.205-3.186a.68.68 0 0 0 .205-.484V8.16z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint7_linear_2434_171178)",
    d: "M111.794 12.15c0-1.528-.876-2.105-3.019-2.646-1.286-.317-1.621-.577-1.621-1.025s.41-.745 1.248-.745c.932.037 1.826.28 2.646.727l.261-1.64a7.4 7.4 0 0 0-2.907-.577c-1.937 0-3.074.987-3.074 2.366 0 1.49.839 2.05 2.851 2.553 1.397.335 1.789.559 1.789 1.155 0 .54-.541.875-1.491.875a6.1 6.1 0 0 1-3.074-.95l-.261 1.658a7.55 7.55 0 0 0 3.242.783c2.236 0 3.41-.95 3.41-2.534m-7.621 2.366v-8.16h-1.975v5.533c-.652.634-1.342 1.044-2.031 1.044-.801 0-1.137-.485-1.137-1.211V6.337h-1.975v5.888c0 1.509.839 2.422 2.441 2.422 1.118 0 2.031-.578 2.832-1.305l.28 1.137zm-8.31 0v-8.16h-1.956v8.16zm-.969-11.738a1.13 1.13 0 0 1 1.137 1.137 1.13 1.13 0 0 1-1.137 1.136 1.13 1.13 0 0 1-1.137-1.136 1.13 1.13 0 0 1 1.137-1.137m-4.118 9.018c-.577.708-1.21 1.155-2.012 1.155-.987 0-1.714-.764-1.714-2.366 0-1.789.857-2.665 2.012-2.665a3.8 3.8 0 0 1 1.714.355zm1.957 2.72V2.386l-1.957.336v3.932a6.5 6.5 0 0 0-1.993-.317c-1.975 0-3.727 1.341-3.727 4.36 0 2.72 1.435 3.987 3.224 3.987 1.192 0 2.012-.596 2.627-1.286l.167 1.118zM82.28 12.28a3.15 3.15 0 0 1-2.087.913c-.67 0-1.1-.372-1.1-.95 0-.782.616-1.472 3.206-1.77v1.807zm1.956 2.236V8.964c0-1.92-1.043-2.702-3.204-2.702a8.8 8.8 0 0 0-3.317.652l.242 1.565a7.9 7.9 0 0 1 2.851-.652c.932 0 1.49.336 1.49 1.211V9.3c-3.465.336-5.142 1.174-5.142 3.13 0 1.398.969 2.236 2.422 2.236a4 4 0 0 0 2.851-1.21l.186 1.043h1.621zm-7.415-.298-3.13-4.267c1.416-.447 2.347-1.434 2.347-3.037 0-2.086-1.509-3.279-4.006-3.279h-3.447v10.881h2.031v-4.21h.988l3.055 4.304zm-2.814-7.192c0 1.137-.857 1.752-2.236 1.752h-1.155V5.312h1.267c1.398.019 2.124.633 2.124 1.714m-6.446 7.49-.243-1.62a4.4 4.4 0 0 1-.708.055c-.8 0-1.118-.354-1.118-1.025V7.94h2.069l-.336-1.584h-1.733V3.523l-1.937.336v2.496h-1.323V7.94h1.323v4.304c0 1.826 1.08 2.385 2.701 2.385.448.019.876-.018 1.305-.112m-5.74-2.366c0-1.528-.875-2.105-3.018-2.646-1.285-.317-1.62-.577-1.62-1.025s.41-.745 1.248-.745c.931.037 1.826.28 2.646.727l.279-1.64a7.4 7.4 0 0 0-2.907-.577c-1.937 0-3.074.987-3.074 2.366 0 1.49.839 2.05 2.85 2.553 1.398.335 1.79.559 1.79 1.155 0 .54-.54.875-1.491.875a5.9 5.9 0 0 1-3.037-.95l-.28 1.658a7.6 7.6 0 0 0 3.261.783c2.18 0 3.354-.95 3.354-2.534m-7.508 2.366v-8.16h-1.975v5.533c-.652.634-1.342 1.044-2.03 1.044-.802 0-1.138-.485-1.138-1.211V6.337h-1.974v5.888c0 1.509.838 2.422 2.44 2.422 1.118 0 2.031-.578 2.832-1.305l.28 1.137zm-8.05-6.353-.446-1.92c-1.249.224-1.994.876-2.572 1.808l-.372-1.696H41.4v8.161h1.919V9.858a3.83 3.83 0 0 1 2.944-1.695"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint8_linear_2434_171178)",
    d: "m42.63 5.44-.446-1.807H32.55V5.44h3.633v9.074h2.031V5.44z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2434_171178",
    x1: 10.804,
    x2: 10.804,
    y1: 18.99,
    y2: 0.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#116BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E50E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2434_171178",
    x1: 16.247,
    x2: 16.247,
    y1: 18.994,
    y2: 0.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#116BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E50E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2434_171178",
    x1: 19.739,
    x2: 28.604,
    y1: 8.983,
    y2: 17.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#116BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#185DEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2434_171178",
    x1: 20.755,
    x2: 20.755,
    y1: 11.999,
    y2: -0.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#116BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E50E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2434_171178",
    x1: 8.445,
    x2: 4.837,
    y1: -0.19,
    y2: 3.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#59C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#21B1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2434_171178",
    x1: 17.512,
    x2: 21.12,
    y1: 0.759,
    y2: 4.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#59C5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#21B1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2434_171178",
    x1: 25.606,
    x2: 22.879,
    y1: 10.271,
    y2: 7.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#57C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#21B1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2434_171178",
    x1: 41.401,
    x2: 111.794,
    y1: 8.535,
    y2: 8.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#116BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E50E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2434_171178",
    x1: 32.551,
    x2: 42.631,
    y1: 9.073,
    y2: 9.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#116BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E50E5"
  })))));
};
export default SvgTrustradius;